import React from "react";
import { Alert } from "@mui/material";
import "./Alerts.scss";

export default function Alerts(props) {
  let alertMessage = "";
  if (props.alertMessage === null) {
    alertMessage = "No errormessage provided";
  } else if (Array.isArray(props.alertMessage)) {
    alertMessage = JSON.stringify(props.alertMessage);
  } else if (typeof props.alertMessage === "string") {
    alertMessage = props.alertMessage;
  } else if (typeof props.alertMessage === "object") {
    if (props.alertMessage.hasOwnProperty("ERRORS")) {
      if (props.alertMessage.ERRORS.toLowerCase() === "invalid request") {
        alertMessage = "Token expired, please log out before trying again";
      } else {
        alertMessage = props.alertMessage.ERRORS;
      }
    } else {
      alertMessage = JSON.stringify(props.alertMessage);
    }
  } else {
    alertMessage = "unhandled errormessage type";
  }

  return (
    <div
      style={{
        width: "100%",
        "& > * + *": {
          marginTop: 2,
        },
      }}
    >
      {props.severity === "error" ? (
        <Alert
          className={props.className + " " + props.severity}
          severity={props.severity}
        >
          {alertMessage}
        </Alert>
      ) : (
        <div />
      )}
      {props.severity === "warning" ? (
        <Alert className="warning" severity="warning">
          Warning!{alertMessage}
        </Alert>
      ) : (
        <div />
      )}
      {props.severity === "info" ? (
        <Alert className="info" severity="info">
          <b>Attempting log in...</b>
          <br />
          {props.username}
          <br />
          {alertMessage}
        </Alert>
      ) : (
        <div />
      )}
      {props.severity === "success" ? (
        <Alert className="success" severity="success">
          Success!{alertMessage}
        </Alert>
      ) : (
        <div />
      )}
    </div>
  );
}
